import * as t from 'io-ts';
export var both = function both(required, optional, name) {
  return t.intersection([t.type(required), t.partial(optional)], name);
};